import React, { useCallback, useEffect, useState } from 'react'
import { getPage } from './api/getPage';
import { useParams } from 'react-router-dom';
import { Preloader } from '../../components/Preloader';
import { sendPageViewEvent } from '../../utils/utils';
import './WpPage.scss';
import './styles/dark.scss';

export function WpPage() {
  const { path } = useParams();
  const [state, setState] = useState(null);

  const init = useCallback(async (path) => {
    try {
      setState(null);

      const data = await getPage(path);

      setState(data);
      document.title = `${data.title} – PokerCoaching.com`;
      sendPageViewEvent(`${data.title} | PokerCoaching.com`);
      if (data.content) {
        const table = document.querySelector('table');
        if (table) {
          table.parentElement.classList.add('scrollShadow');
        }
      }
    } catch(e) {}
  }, []);

  useEffect(() => {
    init(path);

    return () => {
      setState(null);
    };
  }, [path, init]);

  useEffect(() => {
    const links = document.querySelectorAll('td a:first-child:not(.button)')
    const buttons = document.querySelectorAll('td a.button');

    Array.from(links)?.forEach((link, index) => {
      links[index].onclick = () => sendEventToAnalytics(link.innerText, link.href, buttons[index].innerText);
      if (buttons[index]) {
        buttons[index].onclick = () => sendEventToAnalytics(link.innerText, link.href, buttons[index].innerText);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const sendEventToAnalytics = (innerText, href, buttonName) => {
    // actid=30
    window.analytics?.track("button:click", {
      "button_name": buttonName,
      "parent_object_title": state.title,
      "title": innerText,
      "url": href
    });
  }

  return (
    <div className="WpPage">
      {state ? (
        <div className="WpPage__content">
          <div className="WpPage__head">
            <h1 className="WpPage__title">{state.title}</h1>
          </div>
          <div className="WpPage__body" dangerouslySetInnerHTML={{ __html: state.content }} />
        </div>
      ) : (
        <Preloader className="WpPage__preloader" />
      )}
    </div>
  )
}
